export const COMPANY_INFO_HEADER_MARGIN = 36;
export const ENQUIRE_MODAL_SHOWUP_KEY = 'enquire';
export const ENQUIRE_MODAL_SHOWUP_KEY_VALUE = '1';
export const ENQUIRE_MODAL_TYPO_KEY = 'enquiry';
export const ENQUIRE_AUTH_SOURCE_VALUE = 'enquiry';
